'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})

var _templateObject = _taggedTemplateLiteral([''], [''])

var _propTypes = require('prop-types')

var _propTypes2 = _interopRequireDefault(_propTypes)

var _Button = require('./Button')

var _Button2 = _interopRequireDefault(_Button)

var _theme = require('./theme')

var _theme2 = _interopRequireDefault(_theme)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(
    Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })
  )
}

var LargeButton = _Button2.default.extend(_templateObject)

LargeButton.displayName = 'LargeButton'

LargeButton.defaultProps = {
  theme: _theme2.default,
  bg: 'primary',
  color: 'white',
  inverted: false,
  f: [2, 3],
  py: 3,
  px: 4
}

exports.default = LargeButton



//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/dist/LargeButton.js
// module id = 59
// module chunks = 35783957827783 64691314399603 114276838955818 228131777832141